import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";

import Dashboard from "./paginas/dashboard";
import Usuario from "./paginas/usuarios";
import Producto from "./paginas/productos";
import Reportes from "./paginas/reportes";
import SubirExcel from "./paginas/subirexcel";
import Empresas from "./paginas/empresas";
import Impresion from "./paginas/impresion";
import Login from "./paginas/login";
import Estados from "./paginas/pram_estados";
import Ubicaciones from "./paginas/param_ubicaciones";
import Descripciones from "./paginas/param_descripcion";

import { RouterLayout } from "./componentes/RouterLayout";
import PrivateRoute from "./PrivateRoute";

export const AppRutas = () => {
    return (
        <Routes>

            {/* 🔓 LOGIN */}
            <Route path="/login" element={<Login />} />

            {/* 🔐 TODAS PROTEGIDAS */}
            <Route
                path="/"
                element={
                    <PrivateRoute>
                        <RouterLayout />
                    </PrivateRoute>
                }
            >
                <Route index element={<Dashboard />} />
                <Route path="dashboard" element={<Dashboard />} />
                <Route path="empresas" element={<Empresas />} />
                <Route path="usuarios" element={<Usuario />} />
                <Route path="productos" element={<Producto />} />
                <Route path="reportes" element={<Reportes />} />
                <Route path="subirexcel" element={<SubirExcel />} />
                <Route path="impresion" element={<Impresion />} />
                <Route path="ubicaciones" element={<Ubicaciones />} />
                <Route path="estados" element={<Estados />} />
                <Route path="descripcion" element={<Descripciones />} />
            </Route>

            {/* 🔁 CUALQUIER RUTA RARA */}
            <Route path="*" element={<Navigate to="/login" />} />

        </Routes>
    );
};

export default AppRutas;